import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css } from 'styled-components';

import { getMedia, getMediaMin, percent } from '../../../helpers/layout';

export const Background = styled.picture`
    position: absolute;
    display: block;
    bottom: 0;
    left: 0;
    z-index: 10;
    transform: translate(-6.3%,-4.3%);

    @media only screen and ${getMedia('desktop', 'tablet')} {
        transform: translate(-10.6%, -1.7%);
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        transform: translateX(-7.2%);
    }

    @media only screen and ${getMedia('phone')} {
        transform: translateX(-7.2%);
        bottom: ${percent(320, 11)}vw;
    }
`;

export const BackgroundSource = styled.img`
    display: block;
    width: ${percent(1080, 1255)}vh;
    max-width: ${percent(1920, 1255)}vw;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        width: ${percent(750, 855)}vh;
        max-width: ${percent(1366, 855)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        width: ${percent(768, 775)}vw;
        max-width: none;
    }

    @media only screen and ${getMedia('phone')} {
        width: ${percent(320, 357)}vw;
        max-width: none;
    }
`;

export const Content = styled.div`
    width: 100%;
    max-width: ${percent(1920, 485)}vw;
    margin-left: auto;
    display: block;
    align-self: center;
    position: relative;
    z-index: 11;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        max-width: ${percent(1366, 451)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        max-width: ${percent(768, 522)}vw;
        margin-right: auto;
    }

    @media only screen and ${getMedia('phone')} {
        max-width: none;
        margin-left: 0;
    }
`;

export const Form = styled.form`
    background: #FFFFFF;
    border-radius: 4px;
    width: 100%;
    padding: 50px 40px;

    @media only screen and ${getMedia('phone')} {
        padding: 40px 26px;
    }
`;

export const Title = styled.div`
    ${FONTS.H2};
    margin-bottom: 40px;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        ${FONTS.H3};
        margin-bottom: 35px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        ${FONTS.H2};
        margin-bottom: 40px;
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.H4};
        margin-bottom: 30px;
    }
`;

export const Plug = styled.div`
    justify-content: space-between;
    align-items: center;
    ${FONTS.S};
    margin-bottom: 40px;

    &:last-child {
        margin-bottom: 0;
    }

    @media only screen and ${getMedia('phone')} {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Button = styled(BaseButton)`
    align-self: flex-start;
    width: auto;
    ${FONTS.MediumS};

    @media only screen and ${getMedia('phone')} {
        width: 100%;
    }
`;


export const Cost = styled.div`
    display: block;

    & + ${Button} {
        @media only screen and ${getMedia('phone')} {
            margin-top: 30px;
        }
    }
`;

export const CostLink = styled.span`
    border-bottom: 1px solid #1e81d6;
    color: #1e81d6;
    cursor: pointer;
`;


export const Price = styled.div`
    display: inline-block;
    ${FONTS.L};
`;

export const Currency = styled.span`
    ${FONTS.S};
`;

export const Note = styled.div`
    align-items: center;
    ${FONTS.XS};
    background: url("/static/images/icons/gift-blue.svg") 0 0 no-repeat;
    background-size: 27px auto;
    min-height: 27px;
    padding-left: 36px;

    a {
      border-bottom: 1px solid;
    }
`;

export const Support = styled.div`
    display: block;
    color: ${COLORS.TextPrimary};
    position: relative;
    margin-top: 30px;
    padding-left: 30px;

    @media only screen and ${getMedia('phone')} {
        margin-top: 27px;
        padding-left: 33px;
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 5px;
        background: #56CCF2;
        border-radius: 10px;
    }
`;

export const Phone = styled.div`
    text-decoration: none;
    color: #2D9CDB;
    display: inline-block;
`;

export const Section = styled.section`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    background: linear-gradient(65.13deg, #C4C4C4 -10.21%, #D3D5D9 -3.3%, #D5D5D5 46.55%, #FCFCFC 104.65%);
    padding: 127px 199px 129px;
    will-change: opacity;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        padding: 70px 79px 56px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        display: block;
        position: relative;
        padding: 185px 62px ${percent(768, 525)}vw;
        height: auto;
    }

    @media only screen and ${getMedia('phone')} {
        display: block;
        position: relative;
        height: auto;
        padding: 108px 20px ${percent(320, 282)}vw;
    }

    @media only screen and ${getMediaMin('tablet')} {
        ${({ isActive }) => {
            if (isActive) {
                return css`
                    transition: opacity 0.4s ease-out;
                    opacity: 1;
                    z-index: 10;

                    ${Form},
                    ${Support} {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    ${Form} {
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }

                    ${Support} {
                        transition: opacity 0.3s ease-out 0.7s, transform 0.3s ease-out 0.7s;
                    }
                `;
            } else {
                return css`
                    opacity: 0;
                    transition: opacity 0.4s ease-out 0.4s;

                    ${Form},
                    ${Support} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }
                `;
            }
        }}
    }

    @media only screen and (max-aspect-ratio: 4/3) and ${getMediaMin('tablet')} {
        padding-bottom: 30vh;
    }
`;
